import styles from "./Loading.module.scss";
import Spinner from "react-spinkit";
import React from "react";

function Loading() {
  return (
    <div className={styles.loadingContainer}>
      <div className={styles.mainContainer}>
        <Spinner name="circle" className={styles.spinner} />
      </div>
    </div>
  );
}

export default Loading;
